module.exports = __webpack_public_path__ + "static/media/radiation_safety_plan_review_report.8b9e852c.svg";